// extracted by mini-css-extract-plugin
export default {"container":"competitors_container__phifM","leftcontent":"competitors_leftcontent__YvhUE","rightcontent":"competitors_rightcontent__G7GmH"};